const accordions = document.querySelectorAll('.accordion');
const accordionContent = '.accordion__content-wrapper';
const accordionOpenClass = 'accordion--open';

const closeAccordion = (accordion, content) => {
  accordion.classList.remove(accordionOpenClass);
  content.style.height = `0px`;
};

const initAccordion = () => {
  accordions.forEach((accordion) => {
    const heading = accordion.querySelector('.accordion__header');

    heading.addEventListener('click', () => {
      const isOpen = accordion.classList.contains(accordionOpenClass);
      const content = accordion.querySelector(accordionContent);

      if (!isOpen) {
        accordion.classList.add(accordionOpenClass);
        content.style.height = `${content.scrollHeight}px`;
      } else {
        closeAccordion(accordion, content);
      }
    });
  });
};

(() => {
  if (accordions.length) {
    initAccordion();
  }
})();
